import React, { useEffect, useState } from "react";
import axios from "axios";
import facebookLogo from "../Assets/Facebook_Logo_Primary.png";
import instagramLogo from "../Assets/Instagram_Glyph_Gradient.png";
import ttLogo from "../Assets/TikTok_Icon_Black_Square.png";

export default function Media() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://wyrowingbackend.onrender.com/gallery")
      .then((res) => {
        setImages(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load images", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading images...</div>;

  return (
    <div className="centered-page">
      <div
        className="gallery-page"
        style={{ padding: "2rem 2rem", margin: "1rem 1rem" }}
      >
        <h1
          style={{
            color: "#161674",
            fontWeight: "bold",
            fontSize: "2rem",
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          Latest from Facebook
        </h1>
        <div
          className="facebook-feed-container"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div
            className="fb-page"
            data-href="https://www.facebook.com/profile.php?id=100057528674923"
            data-tabs="timeline, events, messages"
            data-width="600"
            data-height="600"
            data-small-header="true"
            data-adapt-container-width="false"
            data-hide-cover="true"
            data-show-facepile="true"
          >
            <blockquote
              cite="https://www.facebook.com/profile.php?id=100057528674923"
              className="fb-xfbml-parse-ignore"
            >
              <a href="https://www.facebook.com/profile.php?id=100057528674923">
                Wyandotte Roosevelt Rowing
              </a>
            </blockquote>
          </div>
        </div>
        <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>
          Find us on Social Media
        </h2>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "3rem",
            marginBottom: "2rem",
          }}
        >
          <a
            href="https://www.instagram.com/wyandotterowing/?fbclid=IwY2xjawK1Z8JleHRuA2FlbQIxMABicmlkETExeHpENDliQnBiUTI1OXZlAR68Oe0D1JDHC7WIxyMKXNZisOOm4CAOeQ-Ctpx33NMEPRAHQZ3UWB17RLR0Yw_aem_yeuQvqGvXgEtxhrBANx3Yg"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              textDecoration: "none",
              color: "#222",
            }}
          >
            <img
              src={instagramLogo}
              alt="Instagram"
              style={{
                width: 80,
                height: 80,
                borderRadius: "16px",
                marginBottom: "0.5rem",
              }}
            />
            <span style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              Instagram
            </span>
          </a>
          <a
            href="https://www.facebook.com/p/Wyandotte-Roosevelt-Rowing-100057528674923/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textDecoration: "none",
              color: "#222",
            }}
          >
            <img
              src={facebookLogo}
              alt="Facebook"
              style={{
                width: 80,
                height: 80,
                borderRadius: "16px",
                marginBottom: "0.5rem",
              }}
            />
            <span style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              Facebook
            </span>
          </a>
          <a
            href="https://www.tiktok.com/@wyandotterowing?_t=8ehRlsbumI2&_r=1&fbclid=PAZXh0bgNhZW0CMTEAAaePCBIjb9ZzQ_IpvXOSVg-IpWpR3-1ETq3HXu4NowjZv4sOSIe7gdPBIXq3Yw_aem_AfVn6nADtTAZFkIc1AnJXQ"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              textDecoration: "none",
              color: "#222",
            }}
          >
            <img
              src={ttLogo}
              alt="TikTok"
              style={{
                width: 80,
                height: 80,
                borderRadius: "16px",
                marginBottom: "0.5rem",
              }}
            />
            <span style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
              TikTok
            </span>
          </a>
        </div>
        <h2 style={{ textAlign: "center" }}>Gallery</h2>
        <div
          className="gallery-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
            gap: "16px",
          }}
        >
          {images.map((file) => (
            <div
              key={file.id}
              className="gallery-item"
              style={{ textAlign: "center" }}
            >
              <a
                href={file.webContentLink.replace(
                  "export=download",
                  "export=view"
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={file.thumbnailLink}
                  alt={file.name}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                  loading="lazy"
                />
              </a>
              <p style={{ marginTop: "0.5rem", fontSize: "0.9rem" }}>
                {file.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
